import Vue from 'vue'

const state = {
    type: 'mission',
    mission: {
        show: false,
        keys: [],
        unlockSuccess: true,
    },
    simulator: {
        show: false,
        keys: [],
        unlockSuccess: true,
    }
}

export const store = Vue.observable(state)

export const mutations = {
    type (payload) {
        Object.assign(store, { type: payload })
    },
    mission (payload) {
        Object.assign(store, { mission: { ...store.mission, ...payload } })
    },
    simulator (payload) {
        Object.assign(store, { simulator: { ...store.simulator, ...payload } })
    },
    isEmpty (type) {
        return store[type].keys.length === 0
    },
    allowedUse (type) {
        return store[type].keys.length === 0 && store[type].show
    }
}
